export const ELF_PREFIX = 'pf-timer-';
